import React from 'react'

import { AcompanhamentoPreNatalContent } from './pre-natal/AcompanhamentoPreNatalContent'

interface AcompanhamentosContentProps {
  prontuarioId: ID
  atendimentoId: ID
  cidadaoId: ID
  dataReferencia: Instant
  vacinacaoPath: string
}

export function AcompanhamentosContent(props: AcompanhamentosContentProps) {
  const { prontuarioId, atendimentoId, cidadaoId, dataReferencia, vacinacaoPath } = props

  return (
    <AcompanhamentoPreNatalContent
      prontuarioId={prontuarioId}
      atendimentoId={atendimentoId}
      cidadaoId={cidadaoId}
      dataReferencia={dataReferencia}
      vacinacaoPath={vacinacaoPath}
    />
  )
  //TODO (Royal Flush): Implementar Acompanhamento de Puerperio
}
